import Login from "./LoginPage";
import Forgotpassword from "./ForgotPasswordPage";
import Resetpassword from "./ResetPasswordPage";
import Signup from "./Signup";
const allloginRoutes = [
  {
    path: "",
    component: <Login />,
  },

  {
    path: "login",
    component: <Login />,
  },

  {
    path: "signup",
    component: <Signup />,
  },

  {
    path: "forgotpassword/",
    component: <Forgotpassword />,
  },

  {
    path: "resetpassword/:uidb64/:token/",
    component: <Resetpassword />,
  },
  {
    path: "resetpassword/",
    component: <Resetpassword />,
  },
];

const DefaultLoginRoute = {
  path: "",
  component: <Login />,
};

const LoginRoute = {
  path: "login",
  component: <Login />,
};

const Signuproute = {
  path: "signup",
  component: <Signup />,
};

const ForgotPasswordRoute = {
  path: "forgotpassword",
  component: <Forgotpassword />,
};

const ResetPasswordRoute = {
  path: "resetpassword/:uidb64/:token/",
  component: <Resetpassword />,
};

export default allloginRoutes;

export {
  DefaultLoginRoute,
  LoginRoute,
  ForgotPasswordRoute,
  ResetPasswordRoute,
  Signuproute,
};
